import { IEmailModel } from "./email-model";

export interface IEmailModelResponse {
    data: {
        success: boolean;
        message: string;
        results: IEmailModel
    }
}
